module.exports = __webpack_public_path__ + "static/media/display-1.31ee80ad.png";